/**
 * Logo Helper Utilities - Reliable logo loading for ExcelJS
 */
import mjLogoPath from "../assets/mnj-logo.jpg";

/**
 * Get logo as base64 data URL for reliable embedding
 */
export const getLogoAsDataURL = async (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          reject(new Error('Could not get canvas context'));
          return;
        }
        
        canvas.width = img.width;
        canvas.height = img.height;
        
        ctx.drawImage(img, 0, 0);
        
        // Convert to data URL
        const dataURL = canvas.toDataURL('image/jpeg', 0.95);
        console.log('✅ Logo converted to data URL');
        resolve(dataURL);
        
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = (error) => {
      console.error('Failed to load logo image:', error);
      reject(new Error('Failed to load logo image for data URL conversion'));
    };
    
    // Set source - this should work reliably in Vite
    img.src = mjLogoPath;
  });
};

/**
 * Convert data URL to buffer for ExcelJS
 */
export const dataURLToBuffer = (dataURL: string): Buffer => {
  // Remove data URL prefix
  const base64Data = dataURL.split(',')[1];
  
  // Convert base64 to buffer
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  return Buffer.from(bytes);
};

/**
 * Reliable logo loading with fallback to data URL method
 */
export const getLogoBuffer = async (): Promise<Buffer> => {
  try {
    console.log('🎨 Loading logo using data URL method...');
    const dataURL = await getLogoAsDataURL();
    const buffer = dataURLToBuffer(dataURL);
    console.log('✅ Logo loaded successfully, size:', buffer.length, 'bytes');
    return buffer;
  } catch (error) {
    console.error('❌ Failed to load logo:', error);
    throw new Error(`Logo loading failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
};